import AdministrarConvenio from "components/convenios/AdministrarConvenio"

export const Convenios = () => {
  return (
    <>
      <AdministrarConvenio></AdministrarConvenio>
    </>
  )
}
